// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zAuthIdentityView = z.object({
    account_role: z.string().optional(),
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    email: z.string().optional(),
    kind: z.string(),
    name: z.string().optional(),
    products: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    role: z.string().optional(),
    sub: z.string(),
    username: z.string().optional()
});

export const zAuthIdentityOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zAuthIdentityView
});

export const zBackgroundView = z.object({
    content_type: z.string(),
    created_at: z.string().datetime(),
    id: z.string(),
    is_system: z.boolean(),
    name: z.string(),
    size_bytes: z.coerce.bigint()
});

export const zCompanyView = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string().optional()
});

export const zCompanyListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zCompanyView),
        z.null()
    ])
});

export const zCompanyProjectBody = z.object({
    company_id: z.string().max(36).optional(),
    project_id: z.string().max(36).optional()
});

export const zCompanyReportRowView = z.object({
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    meeting_count: z.coerce.bigint(),
    private_meeting_count: z.coerce.bigint(),
    seconds: z.coerce.bigint()
});

export const zCompanyReportOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zCompanyReportRowView),
        z.null()
    ])
});

export const zCreateMeetingInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    company_id: z.string().max(36).optional(),
    customer_visible: z.boolean().optional(),
    description: z.string().max(2000).optional(),
    invitees: z.union([
        z.array(z.string()).max(50),
        z.null()
    ]).optional(),
    private: z.boolean().optional(),
    project_id: z.string().max(36).optional(),
    scheduled_at: z.string().datetime().optional(),
    tags: z.union([
        z.array(z.string().max(50)).max(10),
        z.null()
    ]).optional(),
    title: z.string().min(1)
});

export const zMeetingView = z.object({
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    customer_visible: z.boolean(),
    description: z.string().optional(),
    guest_link: z.string(),
    id: z.string(),
    locked: z.boolean(),
    private: z.boolean(),
    project_id: z.string().optional(),
    project_name: z.string().optional(),
    scheduled_at: z.string().datetime().optional(),
    state: z.string(),
    tags: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    title: z.string()
});

export const zCreateMeetingOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zMeetingView
});

export const zDepartmentListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(z.string()),
        z.null()
    ])
});

export const zDetailParticipantView = z.object({
    departments: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    kind: z.string(),
    name: z.string(),
    participant_id: z.string(),
    state: z.string(),
    username: z.string().optional()
});

export const zEmployeeView = z.object({
    departments: z.union([
        z.array(z.string()),
        z.null()
    ]),
    full_name: z.string().optional(),
    id: z.string(),
    subject: z.string(),
    username: z.string()
});

export const zEmployeeListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zEmployeeView),
        z.null()
    ])
});

export const zProjectReportRowView = z.object({
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    meeting_count: z.coerce.bigint(),
    private_meeting_count: z.coerce.bigint(),
    project_id: z.string().optional(),
    project_name: z.string().optional(),
    seconds: z.coerce.bigint()
});

export const zEmployeeReportRowView = z.object({
    companies: z.union([
        z.array(zCompanyReportRowView),
        z.null()
    ]),
    full_name: z.string().optional(),
    meeting_count: z.coerce.bigint(),
    private_meeting_count: z.coerce.bigint(),
    projects: z.union([
        z.array(zProjectReportRowView),
        z.null()
    ]),
    seconds: z.coerce.bigint(),
    subject: z.string(),
    username: z.string().optional()
});

export const zEmployeeReportOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zEmployeeReportRowView),
        z.null()
    ])
});

export const zErrorDetail = z.object({
    location: z.string().optional(),
    message: z.string().optional(),
    value: z.unknown().optional()
});

export const zErrorModel = z.object({
    '$schema': z.string().url().readonly().optional(),
    detail: z.string().optional(),
    errors: z.union([
        z.array(zErrorDetail),
        z.null()
    ]).optional(),
    instance: z.string().url().optional(),
    status: z.coerce.bigint().optional(),
    title: z.string().optional(),
    type: z.string().url().optional().default('about:blank')
});

export const zRecordingCompositeView = z.object({
    ended_at: z.string().datetime().optional(),
    started_at: z.string().datetime().optional(),
    state: z.string(),
    url: z.string().optional()
});

export const zRecordingTrackView = z.object({
    ended_at: z.string().datetime().optional(),
    identity: z.string(),
    participant_id: z.string(),
    started_at: z.string().datetime().optional(),
    state: z.string(),
    url: z.string().optional()
});

export const zRecordingView = z.object({
    composite: zRecordingCompositeView.optional(),
    meeting_id: z.string(),
    state: z.string(),
    tracks: z.union([
        z.array(zRecordingTrackView),
        z.null()
    ])
});

export const zGetRecordingOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zRecordingView
});

export const zGuestMeetingView = z.object({
    meeting_state: z.string(),
    scheduled_at: z.string().datetime().optional(),
    title: z.string()
});

export const zGuestMeetingOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zGuestMeetingView
});

export const zRoomAccessView = z.object({
    meeting_id: z.string(),
    room_token: z.string(),
    signaling: z.string()
});

export const zGuestSessionView = z.object({
    guest_name: z.string(),
    meeting_id: z.string(),
    meeting_state: z.string(),
    participant_id: z.string(),
    room_access: zRoomAccessView.optional(),
    state: z.string(),
    token: z.string()
});

export const zGuestSessionOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zGuestSessionView
});

export const zGuestStateView = z.object({
    meeting_state: z.string(),
    room_access: zRoomAccessView.optional(),
    state: z.string()
});

export const zGuestStateOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zGuestStateView
});

export const zHitView = z.object({
    entity_id: z.string(),
    kind: z.string(),
    label: z.string(),
    matched_in: z.string(),
    meeting_id: z.string().optional(),
    score: z.number(),
    snippet: z.string().optional(),
    url: z.string()
});

export const zInviteInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    subjects: z.union([
        z.array(z.string()).min(1).max(50),
        z.null()
    ])
});

export const zInviteeView = z.object({
    invited_by: z.string().optional(),
    joined: z.boolean(),
    name: z.string().optional(),
    subject: z.string(),
    username: z.string().optional()
});

export const zJoinAsGuestInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    name: z.string().min(1)
});

export const zJoinView = z.object({
    meeting_state: z.string(),
    participant_id: z.string(),
    room_access: zRoomAccessView.optional(),
    state: z.string()
});

export const zJoinOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zJoinView
});

export const zListBackgroundsOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zBackgroundView),
        z.null()
    ])
});

export const zRosterView = z.object({
    kind: z.string(),
    names: z.union([
        z.array(z.string()),
        z.null()
    ]),
    total: z.coerce.bigint()
});

export const zMeetingSummaryView = z.object({
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    created_at: z.string().datetime(),
    customer_visible: z.boolean(),
    ended_at: z.string().datetime().optional(),
    id: z.string(),
    locked: z.boolean(),
    match_sources: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    participant_count: z.coerce.bigint(),
    private: z.boolean(),
    project_id: z.string().optional(),
    project_name: z.string().optional(),
    role: z.string(),
    roster: zRosterView,
    scheduled_at: z.string().datetime().optional(),
    started_at: z.string().datetime().optional(),
    state: z.string(),
    tags: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    title: z.string()
});

export const zListMeetingsOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zMeetingSummaryView),
        z.null()
    ]),
    next_cursor: z.string().optional()
});

export const zLobbyParticipantView = z.object({
    kind: z.string(),
    name: z.string(),
    participant_id: z.string(),
    state: z.string()
});

export const zLobbyListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zLobbyParticipantView),
        z.null()
    ])
});

export const zLobbyView = z.object({
    meeting_id: z.string(),
    participant_id: z.string(),
    state: z.string()
});

export const zLobbyOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zLobbyView
});

export const zOrganizerView = z.object({
    name: z.string(),
    subject: z.string()
});

export const zRecordingRefView = z.object({
    exists: z.boolean(),
    state: z.string().optional()
});

export const zMeetingDetailView = z.object({
    can_delete: z.boolean(),
    can_manage_access: z.boolean(),
    company_id: z.string().optional(),
    company_name: z.string().optional(),
    created_at: z.string().datetime(),
    customer_visible: z.boolean(),
    customer_visible_at: z.string().datetime().optional(),
    customer_visible_by: z.string().optional(),
    customer_visible_by_name: z.string().optional(),
    description: z.string().optional(),
    ended_at: z.string().datetime().optional(),
    guest_link: z.string().optional(),
    id: z.string(),
    invitees: z.union([
        z.array(zInviteeView),
        z.null()
    ]),
    is_organizer: z.boolean(),
    locked: z.boolean(),
    organizer: zOrganizerView,
    participants: z.union([
        z.array(zDetailParticipantView),
        z.null()
    ]),
    private: z.boolean(),
    project_id: z.string().optional(),
    project_name: z.string().optional(),
    recording: zRecordingRefView,
    scheduled_at: z.string().datetime().optional(),
    started_at: z.string().datetime().optional(),
    state: z.string(),
    tags: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    title: z.string(),
    transcript_progress: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(100)),
    transcript_status: z.string()
});

export const zMeetingDetailOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zMeetingDetailView
});

export const zProjectView = z.object({
    company_id: z.string(),
    id: z.string(),
    name: z.string(),
    slug: z.string().optional()
});

export const zProjectListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zProjectView),
        z.null()
    ])
});

export const zProjectReportOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zProjectReportRowView),
        z.null()
    ])
});

export const zRoomAccessOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zRoomAccessView
});

export const zSearchOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zHitView),
        z.null()
    ])
});

export const zSetCustomerVisibilityInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    visible: z.boolean()
});

export const zSetLockInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    locked: z.boolean()
});

export const zSetVisibilityInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    private: z.boolean()
});

export const zTagDictSuggestion = z.object({
    name: z.string(),
    usage_count: z.coerce.bigint()
});

export const zTagSuggestListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    items: z.union([
        z.array(zTagDictSuggestion),
        z.null()
    ])
});

export const zTagsOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    tags: z.union([
        z.array(z.string()),
        z.null()
    ])
});

export const zTagsReplaceInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    tags: z.union([
        z.array(z.string()).max(10),
        z.null()
    ])
});

export const zTranscriptSegment = z.object({
    confidence: z.number().optional(),
    end_ms: z.coerce.bigint(),
    speaker: z.string(),
    speaker_name: z.string(),
    speaker_username: z.string().optional(),
    start_ms: z.coerce.bigint(),
    text: z.string()
});

export const zTranscriptBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    anchor: z.string().datetime().optional(),
    created_at: z.string().datetime(),
    language: z.string(),
    meeting_id: z.string(),
    recording_id: z.string(),
    segments: z.union([
        z.array(zTranscriptSegment),
        z.null()
    ])
});

export const zUpdateMeetingInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    company_project: zCompanyProjectBody.optional(),
    customer_visible: z.boolean().optional(),
    description: z.string().max(2000).optional(),
    scheduled_at: z.string().datetime().optional(),
    tags: z.array(z.string().max(50)).max(10).optional(),
    title: z.string().min(1).max(200).optional()
});

export const zUploadBackgroundOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zBackgroundView
});

export const zAuthIdentityResponse = zAuthIdentityOutputBody;

export const zListBackgroundsResponse = zListBackgroundsOutputBody;

export const zUploadBackgroundResponse = zUploadBackgroundOutputBody;

export const zDeleteBackgroundResponse = z.void();

export const zListCompaniesResponse = zCompanyListOutputBody;

export const zSuggestDepartmentsResponse = zDepartmentListOutputBody;

export const zListEmployeesResponse = zEmployeeListOutputBody;

export const zGuestSessionResponse = zGuestSessionOutputBody;

export const zJoinMeetingAsGuestResponse = zLobbyOutputBody;

export const zGuestMeetingPreviewResponse = zGuestMeetingOutputBody;

export const zGuestLobbyStateResponse = zGuestStateOutputBody;

export const zListMeetingsResponse = zListMeetingsOutputBody;

export const zCreateMeetingResponse = zCreateMeetingOutputBody;

export const zDeleteMeetingResponse = z.void();

export const zGetMeetingResponse = zMeetingDetailOutputBody;

export const zUpdateMeetingResponse = z.void();

export const zAdmitParticipantResponse = zRoomAccessOutputBody;

export const zCancelMeetingResponse = z.void();

export const zSetMeetingCustomerVisibilityResponse = z.void();

export const zEndMeetingResponse = z.void();

export const zInviteEmployeesResponse = z.void();

export const zUninviteEmployeeResponse = z.void();

export const zJoinMeetingResponse = zJoinOutputBody;

export const zListLobbyResponse = zLobbyListOutputBody;

export const zSetMeetingLockResponse = z.void();

export const zKickParticipantResponse = z.void();

export const zMuteParticipantResponse = z.void();

export const zGetRecordingResponse = zGetRecordingOutputBody;

export const zGetTranscriptResponse = zTranscriptBody;

export const zSetMeetingVisibilityResponse = z.void();

export const zListProjectsResponse = zProjectListOutputBody;

export const zCompanyTimeReportResponse = zCompanyReportOutputBody;

export const zEmployeeTimeReportResponse = zEmployeeReportOutputBody;

export const zProjectTimeReportResponse = zProjectReportOutputBody;

export const zSearchResponse = zSearchOutputBody;

export const zSuggestTagsResponse = zTagSuggestListOutputBody;

export const zListEntityTagsResponse = zTagsOutputBody;

export const zReplaceEntityTagsResponse = zTagsOutputBody;